function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.76921 6.1211C8.89921 5.5011 11.6992 7.3111 12.6492 10.0011H20.9992C22.0992 10.0011 22.9992 10.9011 22.9992 12.0011C22.9992 13.1011 22.0992 14.0011 20.9992 14.0011V16.0011C20.9992 17.1011 20.0992 18.0011 18.9992 18.0011C17.8992 18.0011 16.9992 17.1011 16.9992 16.0011V14.0011H12.6492C11.8292 16.3311 9.60921 18.0011 6.99921 18.0011C3.25921 18.0011 0.319207 14.5711 1.13921 10.7011C1.61921 8.4111 3.47921 6.5811 5.76921 6.1211ZM4.99921 12.0011C4.99921 13.1011 5.89921 14.0011 6.99921 14.0011C8.09921 14.0011 8.99921 13.1011 8.99921 12.0011C8.99921 10.9011 8.09921 10.0011 6.99921 10.0011C5.89921 10.0011 4.99921 10.9011 4.99921 12.0011Z",
  fill: "black",
  fillOpacity: 0.54
});

var SvgPasswordLogin = function SvgPasswordLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPasswordLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password-login.51285f39.svg";
export { ForwardRef as ReactComponent };